import React from 'react'
import { Account as AfgAccount } from '@ally/data-types-afg-accounts'
import styled from 'styled-components'
import MobileCardDetail from './MobileCardDetail'
import { AFGAccountDetailsLink } from '../AccountDetailsLink'

const StyledAccountDetailsLink = styled(AFGAccountDetailsLink)`
  width: 100%;
  justify-content: flex-start;
`

const MobileCreditCardsList: React.FC<{
  accounts: AfgAccount[]
}> = ({ accounts }) => {
  return (
    <>
      {accounts.map((account: AfgAccount) => {
        const key = `detail-${account.id}`
        const content = <MobileCardDetail account={account} />

        return (
          <StyledAccountDetailsLink
            account={account}
            text={content}
            key={key}
          />
        )
      })}
    </>
  )
}

export default MobileCreditCardsList
